<template>
  <div class="pt-2">
    <div class="bg-white dark:bg-gray-800 relative shadow-sm sm:rounded-lg border border-gray-200">
      <div class="flex flex-col md:flex-row items-center justify-between space-y-3 md:space-y-0 p-4">
        <div
          class="w-full md:w-auto flex flex-col md:flex-row space-y-2 md:space-y-0 items-stretch md:items-center justify-end flex-shrink-0 ml-auto">
          <a
            href="/users/new"
            class="px-5 py-2 text-sm font-medium text-white inline-flex items-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">

            <svg class="w-5 h-5 me-2 text-gray-200 dark:text-white" aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M5 12h14m-7 7V5" />
            </svg>
            Invite Team Member
          </a>
        </div>
      </div>

      <vue-slim-tables
        ref="table"
        :source="tableSource"
        :columns="columns"
        class="table">

        <!-- eslint-disable-next-line vue/no-template-shadow -->
        <template #thead="{ columns: tableColumns }">
          <tr>
            <th
              v-for="(column) in tableColumns"
              :key="column.key"
              :class="column.class">
              {{ column.title }}
            </th>
          </tr>
        </template>

        <template #row="{ row }">
          <tr>
            <td class="truncate w-48">
              {{ row.email }}
            </td>

            <td class="truncate w-48">
              {{ row.first_name }} {{ row.last_name }}
            </td>

            <td class="truncate">
              <div v-if="!canResendInvitation(row)" class="h-2.5 w-2.5 rounded-full bg-green-500 mr-1 inline-block" />
              <div v-else class="h-2.5 w-2.5 rounded-full bg-yellow-400 mr-1 inline-block" />
              {{ userStatus(row) }}
            </td>

            <td class="truncate">
              <div v-if="canResendInvitation(row)" class="text-right">
                <a href="#" @click.prevent="resendInvitation(row)" class="font-medium text-blue-600 dark:text-blue-500 hover:underline">
                  Resend Invitation
                </a>
              </div>
            </td>
          </tr>
        </template>

        <template #pagination>
          <nav class="flex flex-col md:flex-row justify-between items-start md:items-center space-y-3 md:space-y-0">
            <span class="text-sm font-normal text-gray-500 dark:text-gray-400">
              Showing
              <span class="font-semibold text-gray-900 dark:text-white">{{ props.users.length }}</span>
              of
              <span class="font-semibold text-gray-900 dark:text-white">{{ props.users.length }}</span>
            </span>
          </nav>
        </template>
      </vue-slim-tables>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import VueSlimTables from 'vue-slim-tables'
import securedAxios from '../../utils/axios'
import { toastError, toastSuccess } from '~/javascript/utils/toast'

const axios = securedAxios()

const props = defineProps({
  users: {
    type: Object,
    required: true
  }
})

const table = ref()

const columns = [
  { title: 'Email', key: 'email' },
  { title: 'Name' },
  { title: 'Status' },
  { title: '', key: 'actions', class: 'w-40' }
]

function tableSource() {
  return props.users
}

function userStatus(user) {
  if (user.invitation_sent_at && !user.invitation_accepted_at) {
    return 'Invited'
  }

  return 'Active'
}

function canResendInvitation(user) {
  return 'invitation_sent_at' in user && !('invitation_accepted_at' in user)
}

async function resendInvitation(user) {
  try {
    const response = await axios.post(`/users/${user.id}/resend_invitation`)

    user.invitation_sent_at = response.data.invitation_sent_at
    toastSuccess('The invitation has been successfully sent.')
  } catch (error) {
    toastError(error)
  }
}

</script>

<style scoped>

</style>
